import { ITableReport } from "./TableInterfaces";

export enum RoleAndPermissionTables {
  Permission,
  Role,
  UserRole,
}

export interface IAddEditRoleFormValues {
  roleId: number | null;
  roleName: string;
  permissionIds: number[];
  isPrivate: boolean;
}

export interface IRolesTableSearchParam {
  name?: string;
  permissionId?: number;
}

export interface IAssignedRoleSiteUser {
  id: number;
  name: string;
  userName: string;
}

export interface IRolesTableReport extends ITableReport {
  permissionIds: number[];
  name: string;
  permissionCount: number;
  assignedSiteUserCount: number;
  assignedSiteUsers: IAssignedRoleSiteUser[];
  assignedSiteUserIds: number[];
  isPrivate: boolean;
}

export interface IPermissionsTableSearchParam {
  name?: string;
}

export interface IPermissionsTableReport extends ITableReport {
  parentId: number;
  name: string;
  faName: string;
  clientAddress: string;
  parentFaName: string;
  children: IPermissionsTableReport[];
}

export interface IUserRolesTableSearchParam {
  roleid?: number;
  sahraUserGroupId?: number;
  sahraUserId?: number;
  userid?: number;
}

export interface IUserRolesTableReport extends ITableReport {}

export interface IAssignRoleFormValues {
  siteUserId: number;
  roleId: number;
}

export interface IPermissionItem {
  name: string;
  id: number;
  parentID: number;
  children: IPermissionItem[];
}

export interface IPermissionTreeNode {
  key: string;
  permissionId: number | null;
  title: string;
  policy: string | null;
  description: string | null;
  clientAddress: string | null;
  selectable: boolean;
  children: IPermissionTreeNode[];
}
